export * from "./inspected-brand.component";
